import { EmbeddedPost, FacebookProvider } from "react-facebook";
import { FB_APP_ID } from "@components/MetaTags/constants";
import { useWindowSize } from "@hooks/useWindowSize";

export type FacebookEmbedCustomProps = {
  url: string;
};

export default function FacebookEmbedCustom({
  url,
}: FacebookEmbedCustomProps): React.ReactElement {
  const { isScreenSM } = useWindowSize();

  return (
    <FacebookProvider appId={FB_APP_ID}>
      <div
        className="flex justify-center"
        data-testid="facebook-embed-custom-component"
      >
        <EmbeddedPost
          href={url}
          width={isScreenSM ? "500px" : "auto"}
          lazy
          showText
        />
      </div>
    </FacebookProvider>
  );
}
